import flatpickr from "flatpickr";
import Modal from "./_bootstrapModalExtensions";
import * as Url from "./Utils/UrlUtil";
import * as Dropzone from "./_upload-dropzone";

export function initDropdownMenu() {

    $('.dropdown-submenu').mouseenter(function () {
        // almenük elrejtése
        $(this).parent().find('.dropdown-menu').hide();
        // almenü megjelenítése
        if (window.innerWidth <= 1366) {
            let submenu = $(this).find('.dropdown-menu');
            submenu.css('left', '-' + (submenu.width() + 2) + 'px');
            submenu.show();
        }
        else {
            $(this).find('.dropdown-menu').show();
        }
    });

    $('.dropdown-menu').on('mouseleave', function (event) {
        var dropDownMenu = $(this);
        var $btn = $(this).parent();

        dropDownMenu.attr("aria-collapse-init", "true");
        setTimeout(function () {
            if (dropDownMenu.attr('aria-collapse-init') === "true") {
                if (dropDownMenu.hasClass('dropdown-submenu-container')) {
                    dropDownMenu.hide();
                } else {
                    dropDownMenu.find('.dropdown-submenu-container').hide();
                    $btn.click();
                }
            }
            dropDownMenu.attr("aria-collapse-init", "false");
        }, 650);
    });

    $('.dropdown-menu').on('mouseenter', function () {
        $(this).attr("aria-collapse-init", "false");
    });
}

export function initUnreadMessageCount() {
    var $msgCount = $('#unread-message-count');

    // Nowhere to display (e.g green side, during registration), do nothing
    if ($msgCount.length === 0) {
        return;
    }

    $msgCount.html('<span class="icon-ico-refresh spinner"></span>');

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.UpdateUnreadMessageCount"],
        method: 'POST',
        dataType: 'json',
        success: function (data) {
            $msgCount.html(data.messageCount);
            if (data.messageCount > 0) {
                $msgCount.removeClass("hide");
            } else {
                $msgCount.addClass("hide");
            }
        }
    });
}

function updateLayoutDateTime() {
    $('.clock').text(flatpickr.formatDate(new Date(), 'Y. m. d. H:i:S'));
}

function initBootstrapTooltips() {
    $('[data-toggle="tooltip"]').tooltip()
}

$(function () {
    updateLayoutDateTime();

    setInterval(function () {
        updateLayoutDateTime();
    }, 1000);

    initUnreadMessageCount();
    initDropdownMenu();

    initBootstrapTooltips();
});
